import { atom } from 'recoil';

export const isNewTruckModalOpenAtom = atom<boolean>({
  key: 'isNewTruckModalOpenState',
  default: false,
});
